import categoryService from "app/common/services/categoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import { createUniqueListOfAllDomains } from "pro-features/components/DomainsFilter/Utils";
import { translate } from "app/filters/i18nFilter";
import { getWebsiteTypeOptions } from "app/pages/keyword-analysis/Organic";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

export enum EKAReportTableFilters {
    CATEGORY = "category",
    FUNC_FLAG = "funcFlag",
    DOMAINS = "domains",
}

const getCategoryName = (category: string) => {
    let child: ICategory;
    const categoriesList = categoryService.getCategories().find((cat) => {
        if (cat.id === category) {
            return true;
        }
        if (cat.children) {
            child = cat.children.find((child) => child.id === category);
            return child;
        }
        return false;
    });
    if (categoriesList) {
        return child ? child.text : categoriesList?.text;
    } else if (category.includes("-")) {
        const customList = UserCustomCategoryService.getCustomAndSharedCategories().find(
            (cat) => cat.categoryId === category,
        );
        return customList?.name;
    }
};
const getWebsiteOptionsFilter = (funcFlag: string) => {
    const websiteTypeOptions = getWebsiteTypeOptions();
    const option = websiteTypeOptions.find((option) => option.id === funcFlag.toString());
    return option ? option.text : undefined;
};

export const KeywordAnalysisWidgetFiltersMap = {
    [EKAReportTableFilters.CATEGORY]: (filters) =>
        filters?.category ? (
            <div key={filters.category}>
                {filters.category.includes("-")
                    ? translate("analysis.source.search.keywords.filters.dashboard.customcategory")
                    : translate("analysis.source.search.keywords.filters.dashboard.category")}
                {getCategoryName(filters.category)}
            </div>
        ) : null,
    [EKAReportTableFilters.FUNC_FLAG]: (filters) =>
        filters?.funcFlag ? (
            <div key={filters.funcFlag}>
                {translate("analysis.source.search.keywords.filters.dashboard.websitetype")}
                {translate(getWebsiteOptionsFilter(filters.funcFlag))}
            </div>
        ) : null,

    [EKAReportTableFilters.DOMAINS]: (filters) =>
        filters?.domains ? (
            <div key={filters.domains}>
                {translate("analysis.source.search.keywords.filters.dashboard.domains")}
                {createUniqueListOfAllDomains(filters.domains?.split(","), filters.activationSets).split(",").length}
            </div>
        ) : null,
};

export const KeywordAnalysisTableWidgetAPIParams: EKAReportTableFilters[] = [
    EKAReportTableFilters.CATEGORY,
    EKAReportTableFilters.FUNC_FLAG,
    EKAReportTableFilters.DOMAINS,
];
